export default {
      id: "pattern-plus-left-cropped-usage",
      viewBox: "0 0 157 158",
      url: "../icon/" + "icons.svg#pattern-plus-left-cropped-usage",
      toString: function () {
        return this.url;
      }
    }